export interface SiteAnnouncement {
  id: string
  title: string
  summary: string
  content: string
  category: string
  author: string
  createdAt: string
  views: number
  pinned: boolean
}

const BASE_ANNOUNCEMENTS: SiteAnnouncement[] = [
  {
    id: 'a001',
    title: '2025년 장기요양급여 고시 개정 안내 및 대응 가이드 배포',
    summary: '2025-247호 고시 개정에 따른 급여 산정·청구 변경사항을 정리했습니다.',
    content: '2025년 장기요양급여 제공기준 및 급여비용 산정방법 고시(제2025-247호)가 2026년 1월 1일부터 시행됩니다.\n\n주요 변경사항은 가산 항목 정비, 청구 증빙 기준 강화, 환수 위험 항목 안내입니다. 기관 유형별 체크리스트는 고시 검색 메뉴에서 확인하실 수 있습니다.',
    category: '공통',
    author: '운영팀',
    createdAt: '2026-06-28',
    views: 1240,
    pinned: true,
  },
  {
    id: 'a002',
    title: '통상임금 판결 이후 임금 구조 점검 무료 진단 접수',
    summary: '2024.12 통상임금 판결 이후 소급 청구 리스크를 사전에 점검합니다.',
    content: '2024년 12월 대법원 통상임금 판결 이후, 고정 수당의 포함 여부에 따라 소급 청구 위험이 커졌습니다.\n\n최근 1개월분 임금대장만 제출하시면 무료 진단을 받으실 수 있습니다. 상담 게시판 또는 이메일(hamwoori25@naver.com)로 문의해 주세요.',
    category: '임금',
    author: '임금팀',
    createdAt: '2026-06-25',
    views: 892,
    pinned: true,
  },
  {
    id: 'a003',
    title: '공동구매 7월 카탈로그 업데이트',
    summary: '위생용품·식품 카테고리 신규 품목이 추가되었습니다.',
    content: '7월 공동구매 카탈로그에 성인용 기저귀 대용량, 물티슈 10팩, 견과 선물세트 등이 추가되었습니다. 마감일과 진행률은 공동구매 메뉴에서 확인하세요.',
    category: '쇼핑몰',
    author: '공동구매팀',
    createdAt: '2026-06-20',
    views: 654,
    pinned: false,
  },
  {
    id: 'a004',
    title: '회원가입 안내',
    summary: '아이디·비밀번호(또는 카카오)로 바로 가입할 수 있습니다.',
    content: '일반회원은 아이디와 비밀번호만으로 가입할 수 있습니다. 카카오로도 바로 시작할 수 있습니다. 배송지·연락처는 처음 주문할 때 받으며, 임금·회계 서비스는 담당자 배정 후 이용할 수 있습니다.',
    category: '공통',
    author: '고객지원',
    createdAt: '2026-06-15',
    views: 1103,
    pinned: false,
  },
  {
    id: 'a005',
    title: '상담 운영시간 변경',
    summary: '8월 11일~15일 상담 단축 운영 안내',
    content: '8월 11일(월)부터 15일(금)까지 상담은 10:00–16:00 단축 운영합니다. 온라인 상담 신청은 운영시간과 관계없이 접수할 수 있습니다.',
    category: '공통',
    author: '고객지원',
    createdAt: '2026-06-10',
    views: 421,
    pinned: false,
  },
  {
    id: 'a006',
    title: '임금관리 서비스 요금 안내',
    summary: '카이온 임금·회계 서비스 이용 요금 및 청구 방식 안내',
    content: '임금관리·회계관리 서비스는 기관 규모와 이용 범위에 따라 요금이 책정됩니다. 공동구매만 이용하셔도 되며, 카이온 이용 시 공동구매 추가 할인이 적용됩니다.',
    category: '공통',
    author: '운영팀',
    createdAt: '2026-06-05',
    views: 567,
    pinned: false,
  },
  {
    id: 'a007',
    title: '시스템 점검 안내 (6/30 02:00–04:00)',
    summary: '정기 점검으로 일시적으로 서비스 이용이 제한됩니다.',
    content: '6월 30일(화) 새벽 2시부터 4시까지 서버 점검이 진행됩니다. 점검 시간에는 로그인 및 일부 서비스 이용이 제한될 수 있습니다.',
    category: '공통',
    author: 'IT팀',
    createdAt: '2026-06-01',
    views: 312,
    pinned: false,
  },
  {
    id: 'a008',
    title: '방문요양센터 전용 프로그램 업데이트',
    summary: '청구 업로드·급여 계산 연동 기능이 개선되었습니다.',
    content: '방문요양·방문목욕센터 전용 프로그램에서 청구내역 반영 속도와 명세서 발송 기능이 개선되었습니다. 자세한 내용은 방문요양 서비스 페이지를 참고해 주세요.',
    category: '공통',
    author: 'IT팀',
    createdAt: '2026-05-28',
    views: 445,
    pinned: false,
  },
  {
    id: 'a009',
    title: '개인정보처리방침 개정 안내',
    summary: '2026년 7월 1일 시행되는 개인정보처리방침 개정 내용 안내',
    content: '회원 정보 보관 기간 및 제3자 제공 관련 조항이 일부 개정되었습니다. 개정된 방침 전문은 이용약관 메뉴에서 확인하실 수 있습니다.',
    category: '공통',
    author: '운영팀',
    createdAt: '2026-05-20',
    views: 289,
    pinned: false,
  },
  {
    id: 'a010',
    title: 'AI 고시 해석 서비스 베타 오픈',
    summary: '고시 조문 검색과 AI 해석 기능을 베타로 제공합니다.',
    content: '복잡한 장기요양 고시를 현장 언어로 풀어주는 AI 해석 서비스를 베타로 오픈했습니다. 이용 문의는 상담 게시판으로 접수해 주세요.',
    category: '공통',
    author: '운영팀',
    createdAt: '2026-05-15',
    views: 778,
    pinned: false,
  },
]

/** [제목, 구분, 작성팀, 요약] */
type AnnouncementSeed = [string, string, string, string]

const ANNOUNCEMENT_SEEDS: AnnouncementSeed[] = [
  ['2026년 3분기 장기요양급여 청구 일정 안내', '임금', '운영팀', '3분기 급여비용 청구 접수 일정과 마감일을 안내합니다.'],
  ['요양보호사 처우개선비 지급 기준 변경 안내', '임금', '임금팀', '처우개선비 산정 및 지급 기준이 일부 변경되었습니다.'],
  ['4대보험 요율 조정에 따른 급여 반영 안내', '임금', '임금팀', '변경된 4대보험 요율이 급여 계산에 자동 반영됩니다.'],
  ['연말정산 간소화 자료 제출 가이드 배포', '임금', '임금팀', '연말정산 간소화 자료 수집·제출 절차를 정리했습니다.'],
  ['희망이음 사회서비스정보시스템 연계 점검', '공통', 'IT팀', '희망이음 연계 안정화를 위한 점검을 진행합니다.'],
  ['8월 공동구매 위생용품 특가전 오픈', '쇼핑몰', '공동구매팀', '기저귀·물티슈·장갑 등 위생용품을 특가로 준비했습니다.'],
  ['공동구매 배송 지연 관련 조치 안내', '쇼핑몰', '공동구매팀', '일부 품목 배송 지연에 대한 사과와 조치를 안내합니다.'],
  ['장기요양기관 현지조사 대비 체크리스트', '회계', '회계팀', '현지조사 대비 증빙·서류 준비 체크리스트를 제공합니다.'],
  ['회계 결산 마감 일정 및 제출 서류 안내', '회계', '회계팀', '분기 결산 마감 일정과 필요 서류를 안내합니다.'],
  ['통상임금 소급분 시뮬레이션 도구 업데이트', '임금', '임금팀', '소급분 계산 정확도를 높인 시뮬레이션을 배포했습니다.'],
  ['급여명세서 자동 발송 오류 수정 완료', '임금', 'IT팀', '명세서 자동 발송 지연 오류를 수정했습니다.'],
  ['신규 등급판정 기준 관련 실무 웨비나', '공통', '교육팀', '변경된 등급판정 기준 대응을 위한 온라인 교육을 엽니다.'],
  ['요양보호사 채용 공고 등록 서비스 추가', '공통', '운영팀', '기관에서 직접 채용 공고를 등록할 수 있습니다.'],
  ['재가급여전자관리(RFID) 관련 유의사항', '임금', '운영팀', '태그 인식 및 청구 연계 시 유의사항을 안내합니다.'],
  ['부정수급 예방을 위한 청구 점검 안내', '공통', '운영팀', '부정수급 예방을 위한 청구 자율 점검을 권고합니다.'],
  ['개인정보 보호 교육 이수 안내', '공통', '고객지원', '종사자 개인정보 보호 교육 이수 방법을 안내합니다.'],
  ['명절 연휴 상담 휴무 안내', '공통', '상담', '명절 연휴 기간 상담 운영 일정을 안내합니다.'],
  ['임금대장 엑셀 업로드 양식 변경 안내', '임금', '임금팀', '임금대장 업로드 양식이 개선되어 다시 안내합니다.'],
  ['세무 신고 대행 서비스 신청 접수', '회계', '회계팀', '원천세·부가세 등 세무 신고 대행을 접수합니다.'],
  ['공동구매 정산 방식 개선 안내', '쇼핑몰', '공동구매팀', '정산 주기와 방식이 개선되어 안내합니다.'],
  ['방문요양 청구내역 업로드 개선 배포', '공통', 'IT팀', '청구내역 반영 속도와 안정성이 개선되었습니다.'],
  ['주야간보호 운영일지 서식 배포', '공통', '운영팀', '주야간보호 프로그램 운영일지 표준 서식을 배포합니다.'],
  ['2026년 최저임금 반영 급여 재설계 안내', '임금', '임금팀', '변경된 최저임금을 반영한 급여 재설계를 안내합니다.'],
  ['퇴직연금 도입 관련 상담 접수', '임금', '임금팀', '퇴직연금 도입 검토 기관을 위한 상담을 접수합니다.'],
  ['고시 개정 대응 실무 가이드 3차 배포', '공통', '운영팀', '개정 고시 대응을 위한 실무 가이드를 추가 배포합니다.'],
  ['감사 대비 증빙서류 보관 기준 안내', '회계', '회계팀', '증빙서류 종류별 보관 기간과 방법을 안내합니다.'],
  ['시스템 정기 점검 안내 (7/28 새벽)', '공통', 'IT팀', '정기 점검으로 일부 서비스 이용이 제한됩니다.'],
  ['모바일 앱 신규 버전 출시 안내', '공통', 'IT팀', '알림·명세서 조회가 개선된 신규 앱을 출시했습니다.'],
  ['공동구매 신규 입점 업체 모집', '쇼핑몰', '공동구매팀', '검증된 위생·식품 업체의 입점 신청을 받습니다.'],
  ['요양시설 인력배치기준 변경 안내', '공통', '운영팀', '인력배치기준 변경에 따른 운영 유의사항을 안내합니다.'],
  ['급여 지급일 변경 관련 안내', '임금', '임금팀', '급여 지급일 변경 시 처리 방법을 안내합니다.'],
  ['4대보험 EDI 연동 오류 조치 완료', '임금', 'IT팀', 'EDI 연동 지연 오류를 조치 완료했습니다.'],
  ['회계 프로그램 계정과목 업데이트', '회계', '회계팀', '회계규칙에 맞춰 계정과목을 업데이트했습니다.'],
  ['무료 임금 진단 8월 접수 마감 안내', '임금', '임금팀', '8월 무료 임금 진단 접수 마감일을 안내합니다.'],
  ['장기요양 수가 인상 관련 안내', '공통', '운영팀', '수가 인상에 따른 청구·급여 변동을 안내합니다.'],
  ['종사자 안전보건 교육 자료 배포', '공통', '교육팀', '종사자 안전보건 교육용 자료를 배포합니다.'],
  ['공동구매 반품·교환 정책 안내', '쇼핑몰', '공동구매팀', '공동구매 상품의 반품·교환 기준을 안내합니다.'],
  ['신규 가입 기관 온보딩 가이드', '공통', '고객지원', '가입 후 기능 설정까지 단계별 안내를 제공합니다.'],
  ['비밀번호 보안 강화 정책 적용', '공통', 'IT팀', '계정 보호를 위한 비밀번호 정책이 강화됩니다.'],
  ['요양보호사 명세서 앱 알림 기능 추가', '공통', 'IT팀', '급여명세서 발송 시 앱 푸시 알림을 제공합니다.'],
  ['여름철 위생용품 공동구매 앙코르전', '쇼핑몰', '공동구매팀', '인기 위생용품의 앙코르 공동구매를 진행합니다.'],
  ['회계 예산편성 실무 워크숍 안내', '회계', '회계팀', '예산편성 실무 워크숍 참가 신청을 받습니다.'],
  ['청구 반려 사례 및 대응 방법 안내', '공통', '운영팀', '자주 발생하는 청구 반려 사례와 대응법을 정리했습니다.'],
  ['기관 회계규칙 개정 반영 안내', '회계', '회계팀', '개정된 장기요양기관 회계규칙 반영 사항을 안내합니다.'],
  ['데이터 백업 및 복구 정책 안내', '공통', 'IT팀', '데이터 보관·백업 및 복구 정책을 안내합니다.'],
  ['상담 게시판 답변 지연 관련 안내', '공통', '고객지원', '문의 증가로 답변이 지연될 수 있음을 안내합니다.'],
  ['임금·회계 통합 리포트 기능 오픈', '임금', '운영팀', '임금과 회계를 연계한 통합 리포트를 제공합니다.'],
  ['추석 명절 공동구매 선물세트 사전예약', '쇼핑몰', '공동구매팀', '명절 선물세트 사전예약 혜택을 안내합니다.'],
  ['장기요양기관 평가 대비 안내', '공통', '운영팀', '정기평가 대비 준비사항과 자료를 안내합니다.'],
  ['서비스 이용약관 개정 예고', '공통', '운영팀', '이용약관 개정 예정 사항을 사전 안내합니다.'],
]

function pad2(value: number): string {
  return String(value).padStart(2, '0')
}

function dateBefore(daysAgo: number): string {
  const base = new Date(2026, 4, 12) // 2026-05-12 (a010 이후)
  base.setDate(base.getDate() - daysAgo)
  return `${base.getFullYear()}-${pad2(base.getMonth() + 1)}-${pad2(base.getDate())}`
}

const GENERATED_ANNOUNCEMENTS: SiteAnnouncement[] = ANNOUNCEMENT_SEEDS.map(
  ([title, category, author, summary], index) => ({
    id: `a${String(index + 11).padStart(3, '0')}`,
    title,
    summary,
    content: `${summary}\n\n${title}에 대한 세부 내용은 관련 메뉴에서 확인하실 수 있습니다. 문의 사항은 상담 게시판 또는 이메일(hamwoori25@naver.com)로 접수해 주세요.\n\n※ 본 공지는 데모용 예시 데이터입니다.`,
    category,
    author,
    createdAt: dateBefore(index * 3 + 3),
    views: ((index * 47 + 139) % 1400) + 60,
    pinned: false,
  }),
)

export const SITE_ANNOUNCEMENTS: SiteAnnouncement[] = [
  ...BASE_ANNOUNCEMENTS,
  ...GENERATED_ANNOUNCEMENTS,
]

export function getAnnouncement(id: string): SiteAnnouncement | undefined {
  return SITE_ANNOUNCEMENTS.find((item) => item.id === id)
}
